module.exports = __webpack_public_path__ + "img/DT2.d129c77a.png";